"use client";

import { Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useRanks } from "../../Rank/hooks/use-ranks";
import { getRankImage } from "../../../utils/getRankImage";
import { getRankColor } from "../../../utils/getRankColor";
import MaxRankCard from "./MaxRankCard";

const CustomerVisit = () => {
  const navigate = useNavigate();

  const {
    isLoading,
    currentUserPoints,
    currentRank,
    nextRank,
    currentPointsRank,
    nextPointsRank,
    pointsToNextRank
  } = useRanks();;
  
  if (isLoading) {
    return (
      <Card className="border-0 rounded-4 p-4 bg-dark text-white">
        Cargando...
      </Card>
    );
  }



  const startPoints = currentPointsRank?.points || 0;

  const endPoints = nextPointsRank?.points || startPoints;

  const currentProgress =
    endPoints - startPoints === 0
      ? 100
      : Math.min(
        100,
        Math.max(
          0,
          ((currentUserPoints - startPoints) /
            (endPoints - startPoints)) *
          100
        )
      );

  return (
    <>
      <MaxRankCard maxRank={currentRank} />

      <Card
        className="border-0 rounded-4 p-4 mb-4"
        style={{ background: "#0d1117", color: "#fff" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-bold mb-0">Progreso de Rangos</h4>

          <span
            className="fw-semibold"
            style={{ color: "#D9A441", cursor: "pointer" }}
            onClick={() => navigate("/rank")}
          >
            Ver detalle →
          </span>
        </div>

        <Row>
          {currentPointsRank && (<Col className="text-center">
            <div
              className="mx-auto rounded-circle d-flex align-items-center justify-content-center mb-3"
              style={{ width: 60, height: 60, background: "#3a2a09" }}
            >
              <img
                src={getRankImage(currentPointsRank?.name)}
                alt={currentPointsRank?.name}
                style={{
                  width: 80,
                  height: 80,
                  objectFit: "contain",
                  filter: `drop-shadow(0 0 10px ${getRankColor(currentPointsRank?.name)})`
                }}
              />
            </div>

            <div className="text-secondary mb-2">Rango actual</div>

            <h5 className="fw-bold">{currentPointsRank?.name}</h5>

            <div className="text-light">
              {currentPointsRank?.points.toLocaleString()} pts
            </div>
          </Col>
          )}

          {nextPointsRank && (
            <Col className="text-center">
              <div
                className="mx-auto rounded-circle d-flex align-items-center justify-content-center mb-3"
                style={{ width: 60, height: 60, background: "#12381d" }}
              >
                <img
                  src={getRankImage(nextPointsRank.name)}
                  alt={nextPointsRank.name}
                  style={{
                    width: 80,
                    height: 80,
                    objectFit: "contain",
                    filter: `drop-shadow(0 0 10px ${getRankColor(nextPointsRank.name)})`
                  }}
                />
              </div>

              <div className="text-secondary mb-2">Siguiente rango</div>

              <h5 className="fw-bold">{nextPointsRank.name}</h5>

              <div>{nextPointsRank.points.toLocaleString()} pts</div>
            </Col>
          )}
        </Row>

        <div className="text-center mt-5">
          <h3 className="fw-bold">
            Puntos actuales: {currentUserPoints.toLocaleString()}
          </h3>

          {nextPointsRank && nextPointsRank.points > 0 && (
            <div className="text-secondary mt-2">
              Te faltan {pointsToNextRank.toLocaleString()} puntos para el siguiente rango
            </div>
          )}
        </div>

        <div className="mt-4">
          <div className="progress" style={{ height: 8, background: "#d9d9d9" }}>
            <div
              className="progress-bar"
              style={{
                width: `${currentProgress}%`,
                background: "#D9A441",
              }}
            />
          </div>

          <div className="d-flex justify-content-between mt-2">
            <small>{startPoints.toLocaleString()} pts</small>
            <small>{endPoints.toLocaleString()} pts</small>
          </div>
        </div>
      </Card>

      <Card
        className="border-0 rounded-4 p-4 mb-4"
        style={{ background: "#0d1117", color: "#fff" }}
      >
        <div className="d-flex">
          <div
            className="rounded-circle d-flex align-items-center justify-content-center me-3"
            style={{ width: 45, height: 45, background: "#3a2a09" }}
          >
            <i
              className="ri-trophy-fill"
              style={{ color: "#D9A441", fontSize: "20px" }}
            />
          </div>

          <div>
            <h5 className="fw-bold mb-2">¡Sigue avanzando!</h5>

            <div className="text-secondary">
              Estás cada vez más cerca del siguiente rango:{" "}
              {nextRank?.name}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default CustomerVisit;